import React from "react";
import LoadingBar from "Shared/LoadingBar";
import LoadingMessage from "Shared/LoadingMessage";
import Modal from "src/components/Modal";
import styled from "@emotion/styled";
import useSelector from "src/utils/useSelector";
import { useDispatch } from "react-redux";
import { toggleModal } from "src/store/actions/openModal";

const ModalWrapper = styled(Modal)`
    z-index: 1220301;
`;

const LoadingBarContainer = styled("div")`
    margin: 150px 30px 150px;
`;

export const SuspenseFallbackModal = () => {
    const dispatch = useDispatch();
    const isAppOpen = useSelector((state) => state.onlineShopper.isAppOpen);
    const modalSize = useSelector((state) => (state.onlineShopper.modalSize === "lg" ? "1350px" : "720px"));

    if (!isAppOpen) {
        return null;
    }

    return (
        <ModalWrapper id="osModal" closeModal={() => dispatch(toggleModal())} maxWidth={modalSize} open={isAppOpen}>
            <LoadingBarContainer>
                <LoadingBar />
                <LoadingMessage />
            </LoadingBarContainer>
        </ModalWrapper>
    );
};

export default SuspenseFallbackModal;
